import {Injectable, OnDestroy} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {SaveUserPermissions} from '../../../core/store/users/users.actions';
import {CurrentUserPermissions} from '../../../core/models/current-user-permissions';
import {UserService} from 'src/app/core/services/user.service';
import {Select, Store} from '@ngxs/store';
import {GetServerConnectionStatus} from '../../../core/store/shared/shared.actions';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { LoginService } from 'src/app/core/services/login-service';
import {UsersSelectors} from '../../../core/store/users/users.selectors';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MonitoringService} from '../../../services/logging.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, OnDestroy {
  @Select(UsersSelectors.getPermissions) permissions$: Observable<any>;
  userPermissions;
  private destroy$ = new Subject<boolean>();

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private readonly userService: UserService,
    private readonly loginService: LoginService,
    private readonly store: Store,
    private idle: Idle,
    private keepalive: Keepalive,
    private monitoringService: MonitoringService,
    ) {
    // this.configure();
    let token = localStorage?.getItem('id_token');
    if(!token) return;

    this.oauthService.processIdToken(token, null).then((tokenData: any) => {

      let autoLogoutMinutes: number = 0;

      this.permissions$
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          if (result && result.action.permissions.autoLogoutTimeoutInMinutes) {
            autoLogoutMinutes = parseInt(result.action.permissions.autoLogoutTimeoutInMinutes || 0,10);

            if(!autoLogoutMinutes) return;

            idle.setIdle(1);
            idle.setTimeout(autoLogoutMinutes * 60);
            idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

            idle.onTimeout.subscribe(() => {
              this.loginService.logoutUser();
            });

            keepalive.interval(15);
            this.idle.watch();
          }
        });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  canActivate() {
    if (this.oauthService.hasValidAccessToken() && this.userHasPermissions()) {
      this.store.dispatch(new GetServerConnectionStatus());
      return true;
    } else {
      this.router.navigate(['./login']);
      return false;
    }
  }

  private configure() {
    // this.oauthService.configure(authConfig);
    // this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    // this.oauthService.loadDiscoveryDocument(discoveryDocumentConfig.url);
  }

  async userHasPermissions() {

    if (this.userPermissions) return true;
    try {
      const permissions = await this.userService.getPermissions();

      this.userPermissions = new CurrentUserPermissions(permissions);
      this.store.dispatch(new SaveUserPermissions(this.userPermissions));
      return true;
    } catch (e) {
      this.monitoringService.logException(e);
      return false;
    }

  }
}
